import { createContext } from "react"
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY
export const BASEURL = process.env.REACT_APP_BASEURL
export const UserContext = createContext(null)



